import { getServerRuntimeConfig } from '@/config/runtime/serverRuntimeConfig';
import type { ClientRuntimeConfig } from '@/config/runtime/types';

let cachedConfig: ClientRuntimeConfig | null = null;

const loadConfig = (): ClientRuntimeConfig | null => {
    if (typeof window === 'undefined') {
        return getServerRuntimeConfig().clientConfig;
    }
    try {
        const el = document.getElementById('__BNEF_CONFIG__');
        if (el?.textContent) {
            return JSON.parse(el.textContent) as ClientRuntimeConfig;
        }
    } catch (e) {
        console.warn('Failed to parse __BNEF_CONFIG__:', e);
    }
    return null;
};

export const getClientRuntimeConfig = (): Partial<ClientRuntimeConfig> => {
    if (!cachedConfig) {
        cachedConfig = loadConfig();
    }
    return cachedConfig ?? {};
};
